// Environment configuration that works with both Vite and Jest
// All sensitive configuration should be in .env files, not in code

let env: any = {}

// Try to use Vite environment variables (will be available in Vite dev/build)
try {
  // @ts-ignore - This will be transformed by Vite
  env = import.meta.env
} catch (e) {
  // Fallback to process.env for Jest/Node environments
  // @ts-ignore - process might not be defined in browser
  if (typeof process !== 'undefined' && process.env) {
    // @ts-ignore
    env = process.env
  }
}

// Validate required environment variables
const requiredEnvVars = ['VITE_BACKEND_URI']
const missingVars = requiredEnvVars.filter((varName) => !env[varName])

if (missingVars.length > 0) {
  const errorMessage = `Missing required environment variables: ${missingVars.join(', ')}\nPlease check your .env file`

  // In production, environment variables MUST be provided
  if (env.MODE === 'production' || env.PROD === true) {
    console.error('🚨 CRITICAL: ' + errorMessage)
    console.error('Production build requires VITE_BACKEND_URI to be set via environment variables')
    // Don't provide any fallback in production - force proper configuration
  } else {
    // Only in development, provide a local fallback
    console.warn('⚠️ ' + errorMessage)
    if (!env.VITE_BACKEND_URI) {
      console.warn('Using /api proxy fallback for development only')
      env.VITE_BACKEND_URI = '/api'
    }
  }
}


// Export environment variables without defaults
// If VITE_BACKEND_URI is not set, it will be undefined and should be handled by the application
export const BACKEND_URI = env.VITE_BACKEND_URI

// Export for debugging purposes
export const getEnv = () => env
